import { Component, OnInit,Inject,Output, EventEmitter ,ViewChild } from '@angular/core';
import { FormBuilder, FormGroup,Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { MatDialog } from "@angular/material/dialog";
import { MatStepper } from '@angular/material/stepper';


@Component({
  selector: 'app-add-ecowas-business-config',
  templateUrl: './add-ecowas-business-config.component.html',
  styleUrls: ['./add-ecowas-business-config.component.scss']
})
export class AddEcowasBusinessConfigComponent implements OnInit {

  @ViewChild(MatStepper,{static:false}) stepper: MatStepper;

  addBusinessForm : FormGroup;
  submitted:boolean;
  orgIdData:any;
  validation:boolean=false;


  constructor( private formBuilder:FormBuilder , private endpointsService: EndpointsService,
     private backendApiService: BackendApiService, private spinnerService:Ng4LoadingSpinnerService,
    private MatStepper: MatStepper) { }

  ngOnInit(): void {
    //sessionStorage.setItem('orgIdv','');
    //sessionStorage.removeItem('orgIdv');
    this.addBusinessConfigForm()
    
  }

  addBusinessConfigForm(){
    this.addBusinessForm = this.formBuilder.group({
      orgId :['',Validators.required],
    roamOrgId : ['',Validators.required],
    ecowas_enabled : ['Y'],
    message_enabled :['N'],
    charging_enabled :['Y'],
    iot_signed :['N'],
    tarrif_sno : [],
    tarriff_name : [],
    created_date : [],
    modified_date : [],
    freeRoamValidity :[],
    counterValidity :[],
    messageInterval : [],
    stayHomeInterval : ['7'],
    counterStayHomeInterval : ['1000'],
    ratesApplied : [],
    moc :[],
    mtc:[],
    smsmo:[],
    grps:[],
    dataOthers:[],
    mocNoOfDaysApplied:[],
    mtcNoOfDaysApplied:[],
    smsmoNoOfDaysApplied:[],
    gprsNoOfDaysApplied:[],
    dataNoOfDaysApplied:[],
    communityId:[],
    communityName:[],
    whitelist_enabled:[],
    vistingCountry:[],
    vistingNetwork:[],
    primaryType:[],
    should_run_primary:[],
    should_run_slave:[]
    })
  }
  get f() {
    return this.addBusinessForm.controls;
  }
  onAdd(){
     this.submitted=true;
  
  if (this.addBusinessForm.invalid) {
   return;
  }
 // this.stepper.next();
this.orgIdData =this.addBusinessForm.get('orgId').value;
  // this.addBusinessForm.get('orgId').setValue( this.addBusinessForm.get('orgId').value);
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_BUSINESS_CONFIG +
      '&orgId=' + this.addBusinessForm.get('orgId').value+
      '&roamOrgId=' + this.addBusinessForm.get('roamOrgId').value+
      '&ecowas_enabled=' + this.addBusinessForm.get('ecowas_enabled').value+
      '&message_enabled=' + this.addBusinessForm.get('message_enabled').value+
      '&charging_enabled=' + this.addBusinessForm.get('charging_enabled').value+
      '&iot_signed=' + this.addBusinessForm.get('iot_signed').value+
      '&tarrif_sno=' + this.addBusinessForm.get('tarrif_sno').value+
      '&tarriff_name=' + this.addBusinessForm.get('tarriff_name').value+
      '&created_date=' + this.addBusinessForm.get('created_date').value+
      '&modified_date=' + this.addBusinessForm.get('modified_date').value+
      '&freeRoamValidity=' + this.addBusinessForm.get('freeRoamValidity').value+
      '&counterValidity=' + this.addBusinessForm.get('counterValidity').value+
      '&messageInterval=' + this.addBusinessForm.get('messageInterval').value+
      '&stayHomeInterval=' + this.addBusinessForm.get('stayHomeInterval').value+
      '&counterStayHomeInterval=' + this.addBusinessForm.get('counterStayHomeInterval').value+
      '&ratesApplied=' + this.addBusinessForm.get('ratesApplied').value+
      '&moc=' + this.addBusinessForm.get('moc').value+
      '&mtc=' + this.addBusinessForm.get('mtc').value+
      '&smsmo=' + this.addBusinessForm.get('smsmo').value+
      '&grps=' + this.addBusinessForm.get('grps').value+
      '&dataOthers=' + this.addBusinessForm.get('dataOthers').value+
      '&mocNoOfDaysApplied=' + this.addBusinessForm.get('mocNoOfDaysApplied').value+
      '&mtcNoOfDaysApplied=' + this.addBusinessForm.get('mtcNoOfDaysApplied').value+
      '&smsmoNoOfDaysApplied=' + this.addBusinessForm.get('smsmoNoOfDaysApplied').value+
      '&gprsNoOfDaysApplied=' + this.addBusinessForm.get('gprsNoOfDaysApplied').value+
      '&dataNoOfDaysApplied=' + this.addBusinessForm.get('dataNoOfDaysApplied').value+
      '&communityId=' + this.addBusinessForm.get('communityId').value+
      '&whitelist_enabled=' + this.addBusinessForm.get('communityId').value+
      '&vistingCountry=' + this.addBusinessForm.get('vistingCountry').value+
      '&vistingNetwork=' + this.addBusinessForm.get('vistingNetwork').value
      // +'&primaryType=' + this.addBusinessForm.get('primaryType').value+
      // '&should_run_primary=' + this.addBusinessForm.get('should_run_primary').value+
      // '&should_run_slave=' + this.addBusinessForm.get('should_run_slave').value

      )
      .subscribe(response => {
        console.log("responseeee",response)
  //       if (response === null || response === false ) {
  //         alert('Not Added');
  //         return;
  //       }
  //       else if(response === '{\"status\": \"Record with orgId already exists\"}'){
  //         alert("Record with orgid already exit")
  //       }
  //        else {
  //         alert('Add successfully');        
  //         this.spinnerService.show();
  //sessionStorage.setItem('orgIdv',this.addBusinessForm.get('orgId').value );
  //       }
   })
  }
  }

